export const container = () => ({
    width: '100%',
    maxWidth: '58.875rem',
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: -1,
});
